/**
 * URL-hash keys for the review feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Keys stay colocated with the feature (not centralized) so no cross-feature
 * imports are needed — the same convention as per-feature i18n namespaces.
 */
export const REVIEW_HASH = {
  /** `#approve` — approve-container confirmation (detail page). */
  approve: 'approve',
  /** `#reject` — reject-and-correct dialog (detail page). */
  reject: 'reject',
  /** `#edit` — inline edit mode on the review detail page. */
  edit: 'edit',
  /** `#scan` — camera QR scan dialog (listing). */
  scan: 'scan',
  /** `#bulk-approve` — bulk approve confirmation (action bar). */
  bulkApprove: 'bulk-approve'
} as const;

export type ReviewHashKey = (typeof REVIEW_HASH)[keyof typeof REVIEW_HASH];
